// coloca zero a esquerda
export function leftPad(value: number, totalWidth: number, paddingChar:string='0') {
    var length = totalWidth - value.toString().length + 1;
    return Array(length).join(paddingChar || '0') + value;
  };
  
  